import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b9ea34d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "icon-body"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-search el-input__icon"
}, null, -1));
const _hoisted_3 = {
  class: "icon-list"
};
const _hoisted_4 = ["onClick"];
import icons from '../../assets/iconFonts/iconfont.json';
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick } from "vue";
export default {
  __name: 'index',
  emits: ['selected'],
  setup(__props, {
    emit
  }) {
    const state = reactive({
      name: '',
      iconList: icons.glyphs
    });
    const filterIcons = function () {
      if (state.name) {
        state.iconList = state.iconList.filter(item => item.name.includes(state.name));
      } else {
        state.iconList = icons.glyphs;
      }
    };
    const selectedIcon = function (name) {
      emit('selected', name);
      document.body.click();
    };
    const reset = function () {
      state.name = '';
      state.iconList = icons.glyphs;
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: state.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.name = $event),
        style: {
          "position": "relative"
        },
        clearable: "",
        placeholder: "请输入图标名称",
        onClear: filterIcons,
        onInput: filterIcons
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.iconList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: $event => selectedIcon(item)
        }, [_createElementVNode("i", {
          class: _normalizeClass(["iconfont", `icon-${item.font_class}`])
        }, null, 2), _createElementVNode("span", null, _toDisplayString(item.name), 1)], 8, _hoisted_4);
      }), 128))])]);
    };
  }
};